module.exports = __webpack_public_path__ + "img/KAOA.2ab3f196.png";